(function(){
    angular
        .module('app')
        .directive('datepicker', datepicker);

    datepicker.$inject = ['$timeout', '$parse','$compile','CookiesService']

    function datepicker($timeout, $parse,$compile,CookiesService){
        return {
              restrict: 'AE',
            require: 'ngModel',
            scope: {
                    horas: '=',
                    listadias: '='
                },
            link: function (scope, element, $attrs, ngModel) {
              
                return $timeout(function () {
                    var d = new Date(new Date().getFullYear(), 0, 1);
              
                    var value = $attrs.value;
                    var tomorrow = new Date((new Date()).valueOf()+1000*60*60*24);
                    var $element = $(element);
                    var today = new Date()
                    var yesterday = new Date(today)
                    var timestampold =null;
                    yesterday.setDate(yesterday.getDate() - 1)
                    var picker;
                       console.log($element);
                    var disable =   [{ from: [0,0,0], to: yesterday }];
                    var lastDay;
                 
                    disable.push({ from: lastDay, to: [2999,1,1] })

                    function create(){
                     
                    picker = $element.daterangepicker({
                        // "startDate": moment(d),
                        // "endDate": moment(today),
                      "autoUpdateInput" : false,
                        "locale": {                            
                            "format": "DD-MM-YYYY",
                            "separator": " a ",
                            "applyLabel": "Aplicar",
                            "cancelLabel": "Cancelar",
                            "fromLabel": "De",
                            "toLabel": "hasta",
                            "customRangeLabel": "Custom",
                            "weekLabel": "W",
                            "daysOfWeek": [
                                "Do",
                                "Lu",
                                "Ma",
                                "Mi",
                                "Ju",
                                "Vi",
                                "Sa"
                            ],
                            "monthNames": [
                                "Enero",
                                "Febrero",
                                "Marzo",
                                "Abril",
                                "Mayo",
                                "Junio",
                                "Julio",
                                "Agosto",
                                "Septiembre",
                                "Octubre",
                                "Noviembre",
                                "Diciembre"
                            ],
                        }
                        });
                    
                      scope.$emit('datepickerCreate', { startDate: scope.startDate, endDate: scope.endDate });

                                const startDateGuardadapicker = CookiesService.getCookie('startDate');
                                const endDateGuardadapicker = CookiesService.getCookie('startDate');
                            
                            if (startDateGuardadapicker!= "Invalid date" && endDateGuardadapicker != "Invalid date") {
                                if (startDateGuardadapicker && endDateGuardadapicker) {
                                    scope.startDate = startDateGuardadapicker;
                                    scope.endDate = endDateGuardadapicker;
                                }
                                scope.$apply(); 
                                scope.$emit('dateRangeChanged', { startDate: scope.startDate, endDate: scope.endDate });
                                console.log(typeof scope.startDate);
                                if (scope.startDate != "null" && scope.endDate != "null" 
                                    && scope.startDate != null && scope.endDate != null
                                    && scope.startDate != "undefined" && scope.endDate != "undefined"
                                    && scope.startDate != undefined && scope.endDate != undefined) {
                                    $element.val(scope.startDate+" - "+scope.endDate); 
                                }
                            }
                   }

                        function initializePicker() {

                            picker.on('apply.daterangepicker', function(ev, picker) {
                                scope.startDate = picker.startDate.format('DD/MM/YYYY');
                                scope.endDate = picker.endDate.format('DD/MM/YYYY');
                                scope.$apply(); 
                                scope.$emit('dateRangeChanged', { startDate: scope.startDate, endDate: scope.endDate });
                                $element.val(scope.startDate+" - "+scope.endDate); 

                            });
                        }


                        scope.$watch($attrs.ngModel, function (newValue) {
                      
                            if (newValue != undefined && !isNaN(newValue) && typeof newValue !="string") {
                                scope.$emit('datepickerChange',{select:newValue});
                                $element.pickadate("set",'select', newValue);
                            } 

                        });

                        scope.$on('cleaninputdates', function() {
                            $element.val('');  
               
                        });
                        
                    create();
                    initializePicker();
                });
            }
        };
    }
})();